import { createAction } from 'redux-actions';
import * as types from './types';

export const campusesStart = createAction(types.CAMPUSES_START);
export const campusesSuccess = createAction(types.CAMPUSES_SUCCESS);
export const campusesError = createAction(types.CAMPUSES_ERROR);
